import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'app/modules/shared/components/base.component';

@Component({
  selector: 'page-secretary',
  templateUrl: './home-secretary.component.html',
  styleUrls: ['./home-secretary.component.scss']
})
export class HomeSecretaryComponent extends BaseComponent implements OnInit {

  public chartItens: any[] = [];

  ngOnInit(): void {

    console.log("entrei no compenente de secretaria")

  }

  getChartData() {
    //@TODO buscar dados para o chart da secretária   
    this.chartItens = this.setChartDummyData();   
  }
}
